import React from 'react';
import Meta from '../components/Meta';
import OVR from '../components/OVR';

function PreviewPage(props) {
  return (
    <>
      <Meta title="Preview" />
      <OVR />
    </>
  );
}

export default PreviewPage;
